/* eslint-disable no-case-declarations */
import qs from 'qs'
import { biliBridge, inBiliApp } from '@bilibili/js-bridge'
import { gaonengFormUrl } from '../../config'
import {
  MINI_callup_weixin_game_fail,
  MINI_callup_weixin_game_success,
  MINI_callup_weixin_not_install,
  MINI_item_click,
  MINI_item_cvr_click,
  MINI_pc_weixin_mini_page_fail,
  MINI_pc_weixin_mini_page_success
} from '../constants/reportEvents'
import {
  WARN_page_weixin_game_fail,
  WARN_callup_weixin_not_install
} from '@/canvas/constants/warnEvents'
import { callJSB, isIOS } from '@/canvas/utils'
import { getPlatform, isHarmonyOS, hasAndroidUA, isPad, isPC } from '../../utils/device'
import { getEnvironmentPrefix } from '../../utils'

const WX_ERROR = {
  201: '微信未安装',
  202: '下发数据不合法',
  203: '微信唤起失败'
}

const ANDROID_SUPPORT_WX_VERSION = 6750000
const IOS_SUPPORT_WX_VERSION = 67500000

export default {
  props: {
    reportInfo: {},
    link: {
      type: Object,
      default: () => {}
    }
  },
  inject: ['pageId', 'pageQuery', 'compName', 'compId'],
  data() {
    return {
      platform: '',
      showFloatForm: {
        show: false
      },
      model: '',
      build: ''
    }
  },
  computed: {
    // schemeEvent, downloadEvent, formEvent, linkEvent, wxEvent
    type() {
      return this.link?.type
    },
    href() {
      const { type, behavior } = this.link || {}
      const { form = {}, formMode } = behavior || {}

      if (!type || !behavior) {
        return ''
      }

      switch (type) {
        case 'linkEvent':
          return this.withTrackId(behavior.url)
        case 'schemeEvent':
          return 'javascript:void(0);'
        case 'downloadEvent':
          // const ua = window.navigator.userAgent || ''
          // const system = ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1 ? 'android' : ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) ? 'ios' : 'ios'

          return 'javascript:void(0);'
        case 'formEvent':
          if (formMode === 1) return 'javascript:void(0);'

          return `${gaonengFormUrl}?formId=${behavior.formId}&title=${encodeURIComponent(
            form.title || ''
          )}&msg=${encodeURIComponent(form.successMessage || '')}&${this.pageQuery || ''}&compId=${
            this.compId
          }&is_show_distance_lbs=${window._globalData?.isDownloadIllegal || '0'}&use_ip_location=${
            window._globalData?.useIpLocation || '0'
          }`

        case 'wxEvent':
          return 'javascript:void(0);'
      }
    }
  },
  methods: {
    async handlePCWeixinLaunch(data) {
      try {
        // 1. 获取ticket
        const ticket = await this.getWeixinTicket()

        // 2. 构建跳转参数
        const params = new URLSearchParams()
        params.append('appid', 'wxafc256bf83583323') // 网站应用AppID
        params.append('userName', data.orgId) // 小程序原始ID
        params.append('ticket', ticket)
        params.append('track_id', this.getTrackId())

        // 新增：处理path参数并进行URL编码
        if (data.path) {
          // 对path进行replaceUrl处理，然后URL编码
          const processedPath = data.path
          params.append('path', encodeURIComponent(processedPath))
        }

        // 3. 跳转到PC端微信小程序唤起页面
        // 检测环境并构建完整URL
        const envPrefix = getEnvironmentPrefix()
        const targetUrl = `https://${envPrefix}www.bilibili.com/tetris/wepc/index.html?${params.toString()}`

        console.log('targetUrl', targetUrl)

        // 上报微信小程序中间页跳转成功
        this.$reportUI(MINI_pc_weixin_mini_page_success, {
          targetUrl,
          orgId: data.orgId,
          path: data.path
        })

        window.location.href = targetUrl
      } catch (error) {
        console.error('PC端微信小程序唤起失败:', error)
        // 上报PC端微信小程序页面失败
        this.$reportUI(MINI_pc_weixin_mini_page_fail, {
          reason: error.message || '未知错误'
        })
        // 降级处理：跳转到备用URL
        if (data.url) {
          window.location.href = this.replaceUrl(data.url)
        }
      }
    },
    // 调用主站特殊方法
    async getWeixinTicket() {
      try {
        // 确保使用HTTPS协议
        const url = 'https://passport.bilibili.com/x/passport-login/web/wechat/open_sdk/ticket'
        const formData = new FormData()
        formData.append('sns_platform', 'wechat')
        formData.append('sns_appid', 'wxafc256bf83583323')

        console.log('正在获取微信ticket...', url)

        const response = await fetch(url, {
          method: 'POST',
          body: formData,
          credentials: 'include',
          headers: {
            Accept: 'application/json'
          }
        })

        if (!response.ok) {
          throw new Error(`HTTP错误: ${response.status} ${response.statusText}`)
        }

        const result = await response.json()
        console.log('ticket获取结果:', result)

        if (result.code === 0 && result.data && result.data.ticket) {
          return result.data.ticket
        } else {
          throw new Error(`获取ticket失败: ${JSON.stringify(result)}`)
        }
      } catch (error) {
        console.error('获取微信ticket详细错误:', error)

        // 根据错误类型提供更具体的错误信息
        if (error instanceof TypeError && error.message.includes('fetch')) {
          throw new Error('网络连接失败，请检查网络连接或在B站域名下测试')
        } else if (error.message.includes('CORS')) {
          throw new Error('跨域请求被阻止，请在B站域名下测试')
        } else {
          throw error
        }
      }
    },
    // 唤起类型，同时唤起和跳转
    onClick(ev) {
      const { type, behavior = {} } = this.link || {}

      this.$reportUI(
        MINI_item_click,
        {
          item_name: this.compName,
          item_id: this.compId,
          event_type: type,
          ...this.reportInfo,
          ...(type === 'formEvent' ? { form_mode: behavior.formMode || 0 } : {})
        },
        ev
      )
      this.$reportUI(
        MINI_item_cvr_click,
        {
          event_type: type,
          ...this.reportInfo
        },
        ev
      )
      if (type === 'formEvent' && behavior.formMode === 1) {
        this.showFloatForm.show = true
      }

      if (type === 'wxEvent') {
        return this.wxEventHandler(behavior.wxData)
      }

      if (type === 'schemeEvent') {
        return this.schemeJumpHandler(behavior)
      }
      if (type === 'downloadEvent') {
        if (isHarmonyOS() && !hasAndroidUA()) {
          this.$toast('鸿蒙设备暂不支持应用下载及预约')
          return
        }
        const behaviorItem = behavior[this.getBehaviorPlatform()] || {}
        return this.schemeJumpHandler(behaviorItem)
      }

      this.jumpToHref(this.href)
    },
    jumpToHref(url) {
      /**
       * 兼容部分设备无法跳转
       * */
      if (url) {
        document.location.href = url
      }
      if (url && !isIOS) {
        setTimeout(() => {
          document.location.href = url
        }, 0)
      }
    },
    schemeJumpHandler(data) {
      if ((inBiliApp || isPad()) && data.scheme && data.url) {
        return callJSB({
          method: 'cm.callUpApp',
          data: {
            schemaUrl: this.withTrackId(data.scheme),
            jumpLink: this.withTrackId(data.url)
          },
          callback: (res) => {
            if (res.status !== 1) {
              this.jumpToHref(this.withTrackId(data.url))
            }
          },
          onNotSupport: () => {
            this.jumpToHref(this.withTrackId(data.url))
          }
        })
      }
      this.jumpToHref(this.withTrackId(data.scheme || data.url))
    },
    getModel() {
      if (window.alita) {
        window.alita.getNativeInfo().then((res) => {
          this.model = res.model
          this.build = res.build_id
        })
      }
    },
    wxEventHandler(data) {
      const supportAndroid = this.model === 'android' && this.build >= ANDROID_SUPPORT_WX_VERSION
      const supportIOS = this.model === 'iphone' && this.build >= IOS_SUPPORT_WX_VERSION
      const supportHarmony = isHarmonyOS()
      const self = this

      const downgrade = () => {
        if (!data.url) return
        // 失败跳降级URL
        const downgradeUrl = self.replaceUrl(data.url)
        document.location.href = downgradeUrl
        setTimeout(() => {
          document.location.href = downgradeUrl
        }, 0)
      }
      if (data.id) {
        const wxGameList = window._globalData?.wxGameList || []
        const wxGame = wxGameList.find((item) => item.id === data.id)
        if (wxGame) {
          data.orgId = wxGame.origin_id ? wxGame.origin_id : data.orgId
          data.name = wxGame.name ? wxGame.name : data.name
          data.path = wxGame.game_url ? wxGame.game_url : data.path
          // wxGame.org_id && data.orgId = wxGame.org_id,
          // wxGame.name && data.name = wxGame.name,
          // wxGame.game_url && data.path = wxGame.game_url,
        }
      }
      if (isPC()) {
        this.handlePCWeixinLaunch(data)
        return
      }

      console.log({ orgId: data.orgId, name: data.name, path: data.path })
      if ((inBiliApp && (supportAndroid || supportIOS || supportHarmony)) || isPad()) {
        console.log('调用biliBridge唤起微信小程序')
        biliBridge.callNative({
          method: 'cm.callupWxMini',
          data: {
            wx_program_info: {
              org_id: data.orgId,
              name: data.name,
              path: self.replaceUrl(data.path)
            }
          },
          callback: function (res) {
            console.log('callupWxMini', res)
            if (res.code === 0) {
              self.$reportUI(MINI_callup_weixin_game_success)
            } else {
              self.$reportUI(MINI_callup_weixin_game_fail, { reason: WX_ERROR[res.code] })
              this.$reportWarn(WARN_page_weixin_game_fail, { reason: WX_ERROR[res.code] })
              if (res.code === 201) {
                self.$reportUI(MINI_callup_weixin_not_install)
                this.$reportWarn(WARN_callup_weixin_not_install, { reason: WX_ERROR[res.code] })
              }
              if (data.url) {
                downgrade()
              } else {
                self.$toast(WX_ERROR[res.code])
              }
            }
          }
        })
      } else {
        downgrade()
      }
    },
    replaceUrl(url) {
      if (!url) return ''

      const replaceMap = {
        __TRACKID__: 'track_id',
        __CREATIVEID__: 'creative_id',
        __BUVID__: 'buvid',
        __MID__: 'mid',
        __IMEI__: 'imei',
        __DUID__: 'duid',
        __IDFA__: 'idfa',
        __ANDROIDID__: 'android_id',
        __OS__: 'os',
        __REQUESTID__: 'request_id',
        __SOURCEID__: 'source_id',
        __ADTYPE__: 'adtype'
      }

      const search = (window.location.search || '').slice(1)
      Object.keys(replaceMap).forEach((key) => {
        const field = replaceMap[key]
        search.replace(`${field}=${key}`, `${field}=`)
      })

      const query = qs.parse(search) || {}
      let resUrl = url
      Object.keys(replaceMap).forEach((key) => {
        const field = replaceMap[key]
        if (resUrl.includes(key) && query[field]) {
          resUrl = resUrl.replace(key, query[field])
        }
      })

      return resUrl
    },
    getBehaviorPlatform() {
      return this.platform === 'harmony' ? 'android' : this.platform
    },
    getTrackId() {
      const search = (window.location.search || '')
        .substr(1)
        .replace('track_id=__TRACKID__', 'track_id=')
      if (search === '') {
        return ''
      }

      const query = qs.parse(search) || {}
      const trackId = query.track_id || ''
      return trackId
    },
    withTrackId(url) {
      const search = (window.location.search || '')
        .substr(1)
        .replace('track_id=__TRACKID__', 'track_id=')
      if (!url) {
        return url
      }
      if (search === '') {
        return url
      }

      const query = qs.parse(search) || {}
      const trackId = query.track_id || ''

      if (!trackId) return url

      // 有宏，则将宏无脑替换成实际trackId
      if (url.includes('__TRACKID__')) {
        return url.replace('__TRACKID__', trackId)
      }

      return url
    }
  },
  created() {
    this.getModel()
  },
  mounted() {
    this.platform = getPlatform()
  }
}
